/* eslint-disable react/jsx-props-no-spreading */
import * as ReactDOMClient from 'react-dom/client';
import DonorDetailBlockProvider, { type DonorDetailBlockProps } from './DonorDetailProvider';
import DonorForm from './DonorForm';
import { useDonorNavigation } from './libs/useDonorNavigation';
import PaymentForm from './PaymentForm';

const DonorDetailBlock = (): JSX.Element => {
    const { step } = useDonorNavigation();

    return (
        <div className="container">
            {step === 1 && <DonorForm />}
            {step === 2 && <PaymentForm />}
        </div>
    );
};

interface DonorDetailBlockInitProps {
    el: HTMLDivElement;
    props: DonorDetailBlockProps;
}

const DonorDetailBlockInit = ({ el, props }: DonorDetailBlockInitProps): void => {
    const root = ReactDOMClient.createRoot(el);

    root.render(
        <DonorDetailBlockProvider {...props}>
            <DonorDetailBlock />
        </DonorDetailBlockProvider>
    );
};

export default DonorDetailBlockInit;
